import { Observable } from '../events';

export const conversyEvents = new Observable();
